/**
 * Game-controller mapping for the presenter, tuned to the VR-BOX / MOCUTE
 * Bluetooth teleprompter remote (the common "little black" remote). Button
 * indices below are what this remote actually reports in gamepad mode.
 *
 * Layout (matches the remote's printed labels):
 *   0  trigger / stick-pull-down  -> Play/Pause
 *   12 X  (Page up)               -> back
 *   13 B  (Page down)             -> forward
 *   14 A  (Slow down)             -> slower
 *   15 Y  (Speed up)              -> faster
 *   8  Menu                        -> recall last producer message (handled in the UI)
 */
import type { ScrollControl } from '@goanna-im/shared';
import { NUDGE_SMALL } from '@goanna-im/shared';

/** Button index that recalls the last producer message (not a scroll action). */
export const GAMEPAD_RECALL_BUTTON = 8;

export function gamepadButtonToScroll(index: number): ScrollControl | null {
  switch (index) {
    case 0: // trigger / stick-down
      return { action: 'toggle' };
    case 12: // X — Page up
      return { action: 'nudge', value: -NUDGE_SMALL };
    case 13: // B — Page down
      return { action: 'nudge', value: NUDGE_SMALL };
    case 14: // A — Slow down
      return { action: 'speedDown' };
    case 15: // Y — Speed up
      return { action: 'speedUp' };
    default:
      return null;
  }
}
